import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rp-home-native-speaking-support-schema',
  standalone: true,
  templateUrl: './native-speaking-support-schema.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class NativeSpeakingSupportSchemaComponent {}
